const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm border-t border-gray-200 dark:border-gray-700">
      <div className="container mx-auto py-3 px-4">
        <p className="text-center text-sm text-gray-600 dark:text-gray-300">
          <span className="text-red-500">©</span> {currentYear} Extension Technologies. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
